import React, { ReactElement } from 'react'
import { trackAnalyticsEvent } from '@mindfulchefuk/utils/analytics/amplitude/amplitudeAdapter'
import { Box } from '@mindfulchefuk/design-system/layout/Box'
import routesConfig from '@mindfulchefuk/config/routesConfig'
import { NavCTA } from '@mindfulchefuk/features/Navigation/components/Header/shared/NavCTA'
import { useSignedOutNavMobileContext } from '../SignedOutNav/context/SignedOutNavMobileContext'

type TNavSignUpCTA = {
  fullWidth?: boolean
}

export const NavChooseRecipesCTA = ({
  fullWidth,
}: TNavSignUpCTA): ReactElement => {
  const { handleCloseMobileNav } = useSignedOutNavMobileContext()
  return (
    <NavCTA
      variant="primary"
      testId="nav-cta-sign-up"
      onClick={() => {
        handleCloseMobileNav()
        trackAnalyticsEvent({
          name: 'recipe CTA clicked',
          data: {
            'CTA location': 'header CTA',
          },
        })
      }}
      fullWidth={fullWidth}
      href={routesConfig.chooseRecipes.pathname}
    >
      <Box as="span">Choose recipes</Box>
    </NavCTA>
  )
}
